import { render, staticRenderFns } from "./Userbuy.vue?vue&type=template&id=9b45d032&scoped=true"
import script from "./Userbuy.vue?vue&type=script&lang=js"
export * from "./Userbuy.vue?vue&type=script&lang=js"
import style0 from "./Userbuy.vue?vue&type=style&index=0&id=9b45d032&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b45d032",
  null
  
)

export default component.exports